import { render, staticRenderFns } from "./SubnetPanelBoardShow.vue?vue&type=template&id=18bf6431&"
import script from "./SubnetPanelBoardShow.vue?vue&type=script&lang=js&"
export * from "./SubnetPanelBoardShow.vue?vue&type=script&lang=js&"
import style0 from "./SubnetPanelBoardShow.vue?vue&type=style&index=0&id=18bf6431&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports